import React from 'react';
import classnames from 'classnames';
import { BUTTON_LOADING_CIRCLE } from 'common/utils/constants';
import './HeatmapRetrieveDuplicateNotificationScreen.css';
import { Status } from 'apis/Status';

const DUPLICATION_NOTIFICATION_MESSAGE1 = 'Retrieved Heatmap is a DUPLICATE of an existing file in the Library.';

const DUPLICATION_NOTIFICATION_MESSAGE2 =
  'To save the duplicate Heatmap, select "Save the Duplicate". The duplicate file will be saved on the Desktop as "HMd-Source-Date-Time-Polarization-DeviceID.JSON" where the "d" denotes duplicate.';

const HeatmapRetrieveDuplicateNotificationScreen = (props) => {
  let isFetching = props.persistRasterRecordStatus === Status.PENDING;

  return (
    <div
      id="HeatmapRetrieveDuplicateNotificationScreen_Container"
      className="HeatmapRetrieveDuplicateNotificationScreen_Container"
    >
      <div
        id="HeatmapRetrieveDuplicateNotificationScreen_TopContainer"
        className="HeatmapRetrieveDuplicateNotificationScreen_TopContainer"
      >
        <div
          id="HeatmapRetrieveDuplicateNotificationScreen_HeaderText"
          className={'HeatmapRetrieveDuplicateNotificationScreen_HeaderText'}
        >
          Duplication Notification
        </div>
        <div
          id="HeatmapRetrieveDuplicateNotificationScreen_MessageText"
          className="HeatmapRetrieveDuplicateNotificationScreen_MessageText"
          data-tip={DUPLICATION_NOTIFICATION_MESSAGE1}
        >
          {DUPLICATION_NOTIFICATION_MESSAGE1}
        </div>
        <div
          id="HeatmapRetrieveDuplicateNotificationScreen_MessageText"
          className="HeatmapRetrieveDuplicateNotificationScreen_MessageText"
          data-tip={DUPLICATION_NOTIFICATION_MESSAGE2}
        >
          To save the duplicate Heatmap, select
          <span style={{ fontWeight: 'bold' }}> "Save the Duplicate" </span>. The duplicate file will be saved on the
          Desktop as "HMd-Source-Date-Time-Polarization-DeviceID.JSON" where the{' '}
          <span style={{ fontWeight: 'bold' }}> "d" </span> denotes duplicate.
        </div>
        {props.persistUriCountdown >= props.displayCountdownSeconds && (
          <div
            id="HeatmapRetrieveDuplicateNotificationScreen_MessageText"
            className="HeatmapRetrieveDuplicateNotificationScreen_MessageText"
            // title={countDownMessage}
          >
            The opportunity to Save the Duplicate Heatmap will expire in {'  '}
            <span className="HeatmapRetrieveDuplicateNotificationScreen_Countdown_Timer_Seconds">
              {' '}
              {props.closeDuplicateScreenSeconds - props.persistUriCountdown}
            </span>{' '}
            seconds.
          </div>
        )}
      </div>
      <div
        id="HeatmapRetrieveDuplicateNotificationScreen_BottomContainer"
        className="HeatmapRetrieveDuplicateNotificationScreen_BottomContainer"
      >
        <button
          id="HeatmapRetrieveDuplicateNotificationScreen_Bottom_CancelButton"
          className={classnames({
            HeatmapRetrieveDuplicateNotificationScreen_Bottom_CancelButton: true
            // HeatmapRetrieveDuplicateNotificationScreen_Bottom_CancelButton_Disabled: isFetching
          })}
          onClick={() => {
            props.onClose();
          }}
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={isFetching}
          id="HeatmapRetrieveDuplicateNotificationScreen_Bottom_ActionButton"
          className={classnames({
            HeatmapRetrieveDuplicateNotificationScreen_Bottom_ActionButton: true,
            HeatmapRetrieveDuplicateNotificationScreen_Bottom_ActionButton_Disabled: false
          })}
          onClick={() => {
            props.handleSaveDuplicate();
          }}
        >
          {isFetching ? BUTTON_LOADING_CIRCLE : 'Save the Duplicate'}
        </button>
      </div>
    </div>
  );
};

export default React.memo(HeatmapRetrieveDuplicateNotificationScreen);
